<template>
  <div class="checkout">
    <OfferBar v-if="showOfferBanner" />
    <div class="checkout__content">
      <HeaderSystem
        v-if="isNotDesktop"
        @showPurchaseSummary="showHidePurchaseSummary()"
      />
      <router-view />
      <ContainerRigth
        :show-container-right="showContainerRight"
        :allowMultipleSales="allowMultipleSales"
        @hidePurchaseSummary="showHidePurchaseSummary()"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import { injectPixelScript } from '@/utils/pixels/injectPixelScript'
import OfferBar from '@/views/Checkout/partials/OfferBar/OfferBar.vue'
import HeaderSystem from '@/views/Checkout/partials/Header/Header.vue'
// import ContainerLeft from '@/views/Checkout/partials/ContainerLeft/ContainerLeft.vue'
import ContainerRigth from '@/views/Checkout/partials/ContainerRigth/ContainerRigth.vue'
import checkCookieExists from '@/utils/checkCookieExists'
import checkColorTheme from '@/utils/checkColorTheme'
import { isProduction } from '@/utils/environment'

export default {
  name: 'CheckoutView',
  components: {
    OfferBar,
    HeaderSystem,
    // ContainerLeft,
    ContainerRigth,
  },
  data() {
    return {
      showOfferBanner: false,
      showContainerRight: false,
    }
  },
  computed: {
    ...mapState('Checkout', {
      getLogo: (state) => state.theme.image,
      pixels: (state) => state.pixels,
      store_name: (state) => state.cart.store_name,
      settings: (state) => state.cart.settings,
      cartHash: (state) => state.cartHash,
      allowMultipleSales: (state) => state.cart.payment_link?.allow_multiple_sales ?? true,
    }),
    ...mapGetters('Cart', ['getSettings', 'getStoreName']),
    isNotDesktop() {
      return this.$mq !== 'desktop'
    },
  },
  watch: {
    store_name: {
      deep: true,
      handler(newValue) {
        if (newValue) {
          this.setStoreName()
        }
      },
    },
    settings: {
      deep: true,
      handler(newValue) {
        const { timer } = newValue
        if (timer && timer.enable) {
          this.showOfferBanner = timer.enable
        }
      },
    },
  },
  mounted() {
    this.setColorTheme()
    const { cart } = this.$router.currentRoute.query
    let param = {}
    if (cart) {
      param = { cart }
    }
    this.SET_CART_HASH(param)
    this.loadingCartData()
    this.setClarity()
  },
  methods: {
    ...mapActions('Cart', ['fetchCart']),
    ...mapActions('Checkout', ['states', 'pixel']),
    ...mapMutations('Checkout', ['SET_STORE_ID', 'SET_COLOR_THEME', 'SET_CART_HASH']),
    showHidePurchaseSummary() {
      this.showContainerRight = !this.showContainerRight
    },
    async loadingCartData() {
      try {
        await this.states()
        const { store, cart } = this.cartHash
        const storeId = parseInt(store, 10)

        await this.SET_STORE_ID(storeId)
        await this.fetchCart(cart)
        await this.checkCookie()
        await this.loadCheckoutPixel()
      } catch (error) {
        throw new Error(error)
      }
    },
    async loadCheckoutPixel() {
      try {
        await this.pixel()

        if (this.pixels.length) {
          injectPixelScript(this.pixels, 'checkout')
        }
      } catch (error) {
        throw new Error(error)
      }
    },
    /* eslint-disable */
    setClarity() {
      if (isProduction()) {
        ;(function (c, l, a, r, i, t, y) {
          c[a] =
            c[a] ||
            function () {
              ;(c[a].q = c[a].q || []).push(arguments)
            }
          t = l.createElement(r)
          t.async = 1
          t.src = `https://www.clarity.ms/tag/${i}`
          y = l.getElementsByTagName(r)[0]
          y.parentNode.insertBefore(t, y)
        })(window, document, 'clarity', 'script', 'pps2wh8sou')
      }
    },
    /* eslint-enable */
    checkCookie() {
      if (!checkCookieExists('appmax_checkout_settings')) {
        this.createCookie()
        return
      }
      this.updateCookie()
    },
    createCookie() {
      const cartValue = this.getCartSelectedValues()
      this.$cookies.set('appmax_checkout_settings', cartValue)
      this.setColorTheme()
      this.setStoreName()
      this.showOffer()
    },
    updateCookie() {
      const cartValue = this.getCartSelectedValues()
      if (!_.isEqual(this.$cookies.get('appmax_checkout_settings'), cartValue)) {
        this.$cookies.remove('appmax_checkout_settings')
        this.createCookie()
        return
      }

      this.setColorTheme()
      this.setStoreName()
      this.showOffer()
    },
    getCartSelectedValues() {
      const values = {}
      const wantedProps = ['color', 'image', 'timer']
      wantedProps.forEach((val) => {
        values[val] = this.getSettings[val]
      })
      values.store_name = this.getStoreName
      return values
    },
    setColorTheme() {
      if (!checkCookieExists('appmax_checkout_settings')) {
        this.SET_COLOR_THEME(null)
        return
      }
      this.SET_COLOR_THEME(checkColorTheme(this.$cookies.get('appmax_checkout_settings').color))
    },
    setStoreName() {
      if (checkCookieExists('appmax_checkout_settings')) {
        document.title = `Checkout - ${this.$cookies.get('appmax_checkout_settings').store_name}`
        return
      }

      if (this.store_name) {
        document.title = `Checkout - ${this.store_name}`
      }
    },
    showOffer() {
      if (checkCookieExists('appmax_checkout_settings')) {
        const { timer } = this.$cookies.get('appmax_checkout_settings')
        this.showOfferBanner = timer.enable
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.checkout {
  display: flex;
  flex-direction: column;

  &__content {
    display: flex;
    min-height: 100vh;
  }
}
</style>
